import { render } from "./SingleReservation.vue?vue&type=template&id=686f55a5"
import script from "./SingleReservation.vue?vue&type=script&lang=js"
export * from "./SingleReservation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__